import { Routes } from '@angular/router';
import { authGuard } from './services/guards/auth-guard';
import { aynBrokerGuard } from './services/guards/ayn-broker-guard';
import { roleGuard } from './services/guards/role-guard';
import {
  SuperAdmin_Role,
  Admin_Role,
  Broker_Role,
  Agency_Role,
  
  Developer_Role,
} from './helpers/systemRoles';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/auth/auth.component').then((m) => m.AuthComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/auth/forgot-password/forgot-password').then(
        (m) => m.ForgotPassword
      ),
  },
  {
    path: 'reset-password-otp',
    loadComponent: () =>
      import('./pages/auth/reset-password-otp/reset-password-otp').then(
        (m) => m.ResetPasswordOtp
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/auth/reset-password/reset-password').then(
        (m) => m.ResetPassword
      ),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/registeration/registeration').then(
        (m) => m.RegisterationComponent
      ),
  },
  {
    path: 'main',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadComponent: () =>
      import('./layouts/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent
      ),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'profile',
        canActivate: [roleGuard([Agency_Role, Broker_Role, Developer_Role])],
        loadComponent: () =>
          import('./pages/profile/profile').then((m) => m.ProfileComponent),
      },
      {
        path: 'agencyBroker',
        canActivate: [roleGuard([Agency_Role])],
        canActivateChild: [roleGuard([Agency_Role])],
        loadComponent: () =>
          import(
            './pages/agency-broker-component/agency-broker-component'
          ).then((m) => m.AgencyBrokerComponent),
      },

      {
        path: 'chat',
        canActivate: [aynBrokerGuard],
        canActivateChild: [aynBrokerGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/chat/chat').then((m) => m.Chat),
          },
          {
            path: ':id',
            canActivate: [aynBrokerGuard],
            canActivateChild: [aynBrokerGuard],
            loadComponent: () =>
              import('./pages/chat/chat').then((m) => m.Chat),
          },
          {
            path: ':id/payment-request',
            loadComponent: () =>
              import(
                './pages/chat/payment-request/ask-for-payment/ask-for-payment'
              ).then((m) => m.AskForPaymentPage),
          },
          {
            path: ':id/payment-request/edit',
            loadComponent: () =>
              import(
                './pages/chat/payment-request/ask-for-payment/ask-for-payment'
              ).then((m) => m.AskForPaymentPage),
          },
          {
            path: ':id/payment-request/review',
            loadComponent: () =>
              import(
                './pages/chat/payment-request/review-invoices/review-invoices'
              ).then((m) => m.ReviewInvoicesPage),
          },
          {
            path: ':id/payment-request/track',
            loadComponent: () =>
              import(
                './pages/chat/payment-request/track-invoices/track-invoices'
              ).then((m) => m.TrackInvoicesPage),
          },
        ],
      },

      {
        path: 'user',
        canActivate: [roleGuard([SuperAdmin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role])],
        children: [
          {
            path: '',
            redirectTo: 'admins',
            pathMatch: 'full',
          },
          {
            path: 'admins',
            loadComponent: () =>
              import('./pages/UserManagment/admin-users/admin-users').then(
                (m) => m.AdminUsersComponent
              ),
          },
          {
            path: 'admins/add',
            loadComponent: () =>
              import(
                './pages/UserManagment/admin-users/admin-user-details/admin-user-details'
              ).then((m) => m.AdminUserDetails),
          },
          {
            path: 'admins/details',
            loadComponent: () =>
              import(
                './pages/UserManagment/admin-users/admin-user-details/admin-user-details'
              ).then((m) => m.AdminUserDetails),
          },
          {
            path: 'clients',
            loadComponent: () =>
              import('./pages/UserManagment/client-users/client-users').then(
                (m) => m.ClientUsersComponent
              ),
          },
          {
            path: 'developers',
            loadComponent: () =>
              import(
                './pages/UserManagment/developer-users/developer-users'
              ).then((m) => m.DeveloperUsersComponent),
          },
          {
            path: 'developers/details',
            loadComponent: () =>
              import(
                './pages/UserManagment/developer-users/developer-user-details/developer-user-details'
              ).then((m) => m.DeveloperUserDetails),
          },
          {
            path: 'brokers',
            loadComponent: () =>
              import(
                './pages/UserManagment/ayn-broker-users/ayn-broker-users'
              ).then((m) => m.AynBrokerUsersComponent),
          },
          {
            path: 'brokers/details',
            loadComponent: () =>
              import(
                './pages/UserManagment/ayn-broker-users/ayn-broker-details/ayn-broker-details'
              ).then((m) => m.AynBrokerDetails),
          },
          {
            path: 'agencies',
            loadComponent: () =>
              import('./pages/UserManagment/agency-users/agency-users').then(
                (m) => m.AgencyUsersComponent
              ),
          },
          {
            path: 'agencies/details',
            loadComponent: () =>
              import(
                './pages/UserManagment/agency-users/agency-details/agency-details'
              ).then((m) => m.AgencyDetails),
          },
          {
            path: 'agency-brokers',
            loadComponent: () =>
              import(
                './pages/UserManagment/agency-broker-users/agency-broker-users'
              ).then((m) => m.AgencyBrokerUsersComponent),
          },
          {
            path: 'agency-brokers/details',
            loadComponent: () =>
              import(
                './pages/UserManagment/agency-broker-users/agency-broker-details/agency-broker-details'
              ).then((m) => m.AgencyBrokerDetails),
          },
        ],
      },
      {
        path: 'privacypolicy',
        canActivateChild: [roleGuard([SuperAdmin_Role])],
        loadComponent: () =>
          import('./pages/privacy-policy/privacy-policy').then(
            (m) => m.PrivacyPolicyComponent
          ),
      },
      {
        path: 'cancelationRequest',
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import(
            './pages/Requests/cancelation-request/cancelation-request'
          ).then((m) => m.CancelationRequest),
      },
      {
        path: 'propertyVerificationRequest',
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import(
            './pages/Requests/property-verifcation-requests/property-verifation-requests'
          ).then((m) => m.PropertyVerifationRequests),
      },
      {
        path: 'terms',
        canActivateChild: [roleGuard([SuperAdmin_Role])],
        loadComponent: () =>
          import(
            './pages/terms-terms-and-conditions/terms-terms-and-conditions'
          ).then((m) => m.TermsTermsAndConditions),
      },
      {
        path: 'project',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role])],
        canActivateChild: [
          roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role]),
        ],
        loadComponent: () =>
          import('./pages/project/project').then((m) => m.ProjectComopnent),
      },
      {
        path: 'project/add',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role])],
        loadComponent: () =>
          import('./pages/project/project-details/project-details').then(
            (m) => m.ProjectDetails
          ),
      },
      {
        path: 'project/details',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role])],
        loadComponent: () =>
          import('./pages/project/project-details/project-details').then(
            (m) => m.ProjectDetails
          ),
      },

      {
        path: 'event',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role ,Broker_Role])],
        canActivateChild: [
          roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role ,Broker_Role]),
        ],
        loadComponent: () =>
          import('./pages/event/event').then((m) => m.EventComponent),
      },
      {
        path: 'event/add',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role ,Broker_Role])],
        loadComponent: () =>
          import('./pages/event/event-details/event-details').then(
            (m) => m.EventDetails
          ),
      },
      {
        path: 'event/details',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role ,Broker_Role])],
        loadComponent: () =>
          import('./pages/event/event-details/event-details').then(
            (m) => m.EventDetails
          ),
      },
      {
        path: 'event/view',
        canActivate: [roleGuard([Broker_Role])],
        loadComponent: () =>
          import('./pages/event/event-broker-view/event-broker-view').then(
            (m) => m.EventBrokerView
          ),
      },
      {
        path: 'eventOrganizer',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role])],
        canActivateChild: [
          roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role]),
        ],
        loadComponent: () =>
          import('./pages/event-organizer/event-organizer-component').then(
            (m) => m.EventOrganizerComponent
          ),
      },
      {
        path: 'reel',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role,Broker_Role])],
        canActivateChild: [
          roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role,Broker_Role]),
        ],
        loadComponent: () =>
          import('./pages/reel/reel').then((m) => m.ReelComponent),
      },
      {
        path: 'reel/add',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role,Broker_Role])],
        loadComponent: () =>
          import('./pages/reel/reel-details/reel-details').then(
            (m) => m.ReelDetails
          ),
      },
      {
        path: 'reel/details',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role, Developer_Role,Broker_Role])],
        loadComponent: () =>
          import('./pages/reel/reel-details/reel-details').then(
            (m) => m.ReelDetails
          ),
      },

      {
        path: 'groups',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/groups/groups').then((m) => m.GroupsComponent),
      },

      {
        path: 'setup',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/setups/setup-layout/setup-layout').then(
            (m) => m.SetupLayoutComponent
          ),
        children: [
          {
            path: '',
            redirectTo: 'legalAdvisor',
            pathMatch: 'full',
          },
          {
            path: 'legalAdvisor',
            loadComponent: () =>
              import('./pages/setups/legal-advisor/legal-advisor').then(
                (m) => m.LegalAdvisorComponent
              ),
          },
          {
            path: 'propertyManager',
            loadComponent: () =>
              import(
                './pages/setups/property-manager-component/property-manager-component'
              ).then((m) => m.PropertyManagerComponent),
          },
          {
            path: 'paymentMethods',
            loadComponent: () =>
              import('./pages/setups/payment-method/payment-method').then(
                (m) => m.PaymentMethodComponent
              ),
          },
          {
            path: 'kitchenType',
            loadComponent: () =>
              import('./pages/setups/kitchen-type/kitchen-type').then(
                (m) => m.KitchenTypeComponent
              ),
          },
          {
            path: 'industry',
            loadComponent: () =>
              import('./pages/setups/industry/industry').then(
                (m) => m.IndustryComponent
              ),
          },
          {
            path: 'monthlyIncomeRange',
            loadComponent: () =>
              import(
                './pages/setups/monthly-income-range/monthly-income-range'
              ).then((m) => m.MonthlyIncomeRangeComponent),
          },
          {
            path: 'employmentStatus',
            loadComponent: () =>
              import('./pages/setups/employment-status/employment-status').then(
                (m) => m.EmploymentStatusComponent
              ),
          },
          {
            path: 'yearsOfExperience',
            loadComponent: () =>
              import(
                './pages/setups/years-of-experience/years-of-experience'
              ).then((m) => m.YearsOfExperienceComponent),
          },
          {
            path: 'nationality',
            loadComponent: () =>
              import('./pages/setups/nationality/nationality').then(
                (m) => m.NationalityComponent
              ),
          },
          {
            path: 'terms',
            loadComponent: () =>
              import(
                './pages/terms-terms-and-conditions/terms-terms-and-conditions'
              ).then((m) => m.TermsTermsAndConditions),
          },
          {
            path: 'settings',
            loadComponent: () =>
              import('./pages/setups/setting/setting').then(
                (m) => m.SettingComponent
              ),
          },
        ],
      },

      {
        path: 'amenity',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/amenity/amenity').then((m) => m.AmenityComponent),
      },

      {
        path: 'requests',
        canActivate: [roleGuard([Broker_Role])],
        canActivateChild: [roleGuard([Broker_Role])],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/Requests/broker-requests/broker-requests').then(
                (m) => m.BrokerRequestsComponent
              ),
          },
          {
            path: 'by-owner/:id',
            loadComponent: () =>
              import(
                './pages/Requests/broker-requests/by-owner/by-owner-details/by-owner-details'
              ).then((m) => m.ByOwnerDetailsComponent),
          },
          {
            path: 'by-owner/:id/submit',
            loadComponent: () =>
              import(
                './pages/Requests/broker-requests/by-owner/submit-proposal/submit-proposal'
              ).then((m) => m.SubmitProposalComponent),
          },
          {
            path: 'representation/:id',
            loadComponent: () =>
              import(
                './pages/Requests/broker-requests/representation/representation-details/representation-details'
              ).then((m) => m.RepresentationDetailsComponent),
          },
          {
            path: 'representation/:id/resubmit',
            loadComponent: () =>
              import(
                './pages/Requests/broker-requests/representation/resubmit-proposal/resubmit-proposal'
              ).then((m) => m.ResubmitProposalComponent),
          },
        ],
      },

      {
        path: 'property',
        canActivate: [
          roleGuard([
            SuperAdmin_Role,
            Admin_Role,
            Broker_Role,
            Agency_Role,
            
          ]),
        ],
        canActivateChild: [
          roleGuard([
            SuperAdmin_Role,
            Admin_Role,
            Broker_Role,
            Agency_Role,
            
          ]),
        ],
        loadComponent: () =>
          import('./pages/property/property').then((m) => m.PropertyComponent),
      },

      {
        path: 'property/add',
        canActivate: [
          roleGuard([
            SuperAdmin_Role,
            Admin_Role,
            Broker_Role,
            Agency_Role,
            
          ]),
        ],
        canActivateChild: [
          roleGuard([
            SuperAdmin_Role,
            Admin_Role,
            Broker_Role,
            Agency_Role,
            
          ]),
        ],
        loadComponent: () =>
          import('./pages/property/add-property/add-property').then(
            (m) => m.AddPropertyComponent
          ),
      },
      {
        path: 'property/:id',
        canActivate: [
          roleGuard([
            SuperAdmin_Role,
            Admin_Role,
            Broker_Role,
            Agency_Role,
            
          ]),
        ],
        canActivateChild: [
          roleGuard([
            SuperAdmin_Role,
            Admin_Role,
            Broker_Role,
            Agency_Role,
            
          ]),
        ],
        loadComponent: () =>
          import('./pages/property/property-details/property-details').then(
            (m) => m.PropertyDetailsComopnent
          ),
      },
   
      {
        path: 'legalAdvisor',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/setups/legal-advisor/legal-advisor').then(
            (m) => m.LegalAdvisorComponent
          ),
      },
      {
        path: 'propertyManager',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import(
            './pages/setups/property-manager-component/property-manager-component'
          ).then((m) => m.PropertyManagerComponent),
      },
      {
        path: 'currency',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/setups/currency/currency').then(
            (m) => m.CurrencyComponent
          ),
      },

      {
        path: 'monthlyIncomeRange',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import(
            './pages/setups/monthly-income-range/monthly-income-range'
          ).then((m) => m.MonthlyIncomeRangeComponent),
      },
      {
        path: 'employmentStatus',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/setups/employment-status/employment-status').then(
            (m) => m.EmploymentStatusComponent
          ),
      },
      {
        path: 'industry',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/setups/industry/industry').then(
            (m) => m.IndustryComponent
          ),
      },
      {
        path: 'yearsOfExperience',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/setups/years-of-experience/years-of-experience').then(
            (m) => m.YearsOfExperienceComponent
          ),
      },
      {
        path: 'nationality',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/setups/nationality/nationality').then(
            (m) => m.NationalityComponent
          ),
      },

      {
        path: 'kitchenType',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/setups/kitchen-type/kitchen-type').then(
            (m) => m.KitchenTypeComponent
          ),
      },

      {
        path: 'paymentMethods',
        canActivate: [roleGuard([SuperAdmin_Role, Admin_Role])],
        canActivateChild: [roleGuard([SuperAdmin_Role, Admin_Role])],
        loadComponent: () =>
          import('./pages/setups/payment-method/payment-method').then(
            (m) => m.PaymentMethodComponent
          ),
      },
    ],
  },

  {
    path: '**',
    redirectTo: 'main/dashboard',
  },

  {
    path: '',
    redirectTo: 'main/dashboard',
    pathMatch: 'full',
  },
];
